import { ADVANCED, BRANDING, PROGRESS_TRACKER } from '@opengov/stories-shared/constants';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { ISettings, IStoriesSettingsMessages } from '../../../../types';
import { Analytics } from '../Analytics';
import { ColorSelectors } from '../ColorSelectors';
import { FontSelectors } from '../FontSelectors';
import { LogoUpload } from '../LogoUpload';
import { SideNav } from '../SideNav';
import { StoryPreview } from '../StoryPreview';
import { ProgressTrackerSettings } from '../ProgressTrackerSettings';
import { ProgressTrackerSettingsProvider } from '../ProgressTrackerSettings/context/ProgressTracker.Provider';
import { styles } from './Content.styles';

export type IContentProps = {
  entityId?: number;
  entitySubdomain: string;
  isPreviewLoading: boolean;
  settings: ISettings;
  messages: IStoriesSettingsMessages;
  previewUrl: string;
  activeTab: string;
  setActiveTab(tab: string): void;
  updateSettingsProps(newSettingsProps: Partial<ISettings>): void;
  deleteStoryEmbed?(props: { storyId: string; embedId: string }): Promise<void>;
  updateSettings(event: React.MouseEvent<HTMLElement>): void;
  showProgressTracker?: boolean;
};

export const Content = ({
  entityId = 0,
  entitySubdomain,
  isPreviewLoading,
  settings,
  messages,
  previewUrl,
  activeTab,
  setActiveTab,
  updateSettingsProps,
  updateSettings,
  showProgressTracker
}: IContentProps) => {
  const renderBranding = () => (
    <Box sx={styles.tabSection}>
      <Box sx={styles.headerRow}>
        <LogoUpload settings={settings} messages={messages} entitySubdomain={entitySubdomain} updateSettingsProps={updateSettingsProps} />
        <Button variant="outlined" color="primary" onClick={updateSettings} sx={styles.saveButton}>{messages.save}</Button>
      </Box>
      <Box sx={styles.brandingContent}>
        <Box sx={styles.colorsPreviewRow}>
          <ColorSelectors settings={settings} messages={messages} updateSettingsProps={updateSettingsProps} />
          <StoryPreview previewUrl={previewUrl} messages={messages} isPreviewLoading={isPreviewLoading} />
        </Box>
        <FontSelectors settings={settings} messages={messages} updateSettingsProps={updateSettingsProps} />
      </Box>
    </Box>
  );

  const renderAdvanced = () => (
    <Box sx={styles.tabSection}>
      <Box sx={styles.headerRow}>
        <Analytics settings={settings} messages={messages} updateSettingsProps={updateSettingsProps} />
        <Button variant="outlined" color="primary" onClick={updateSettings} sx={styles.saveButton}>{messages.save}</Button>
      </Box>
    </Box>
  );

  const renderProgressTracker = () => (
    <Box sx={styles.progressTrackerSection}>
      <ProgressTrackerSettingsProvider entityId={entityId}>
        <ProgressTrackerSettings messages={messages} />
      </ProgressTrackerSettingsProvider>
    </Box>
  );

  return (
    <Box component="main" id="mainContent" sx={styles.root}>
      <SideNav messages={messages} activeTab={activeTab} setActiveTab={setActiveTab} showProgressTracker={showProgressTracker} />
      {activeTab === BRANDING && renderBranding()}
      {activeTab === ADVANCED && renderAdvanced()}
      {activeTab === PROGRESS_TRACKER && renderProgressTracker()}
    </Box>
  );
};
